<template>
  <f7-page class="page-force-change-password">
    <f7-navbar title="ĐỔI MẬT KHẨU BẮT BUỘC"></f7-navbar>
    <f7-list inset>
      <f7-list-input
          placeholder="Mật khẩu mới"
          type="password"
          pattern="[0-9]{8}"
          inputmode="numeric"
          maxlength="8"
          info="Mật khẩu gồm 8 số"
          :value="form_password.new_password"
          @input="form_password.new_password = $event.target.value"
      >
        <f7-icon slot="media" ios="f7:lock"></f7-icon>
      </f7-list-input>
      <f7-list-input
          placeholder="Nhập lại MK mới"
          type="password"
          pattern="[0-9]{8}"
          inputmode="numeric"
          maxlength="8"
          :value="form_password.new_password_confirmation"
          @input="form_password.new_password_confirmation = $event.target.value"
      >
        <f7-icon slot="media" ios="f7:lock"></f7-icon>
      </f7-list-input>
    </f7-list>
    <f7-block class="mt-1">
      <f7-button fill color="red" @click.prevent="submitChange">XÁC NHẬN</f7-button>
    </f7-block>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';

export default {
  props:{
    old_password: String
  },
  computed  :{
    ...mapState(['user_info'])
  },
  data(){
    return {
      form_password:{
        old_password             :'',
        new_password             :'',
        new_password_confirmation:''
      }
    }
  },
  methods:{
    submitChange(){
      this.$f7.preloader.show();

      this.$store.dispatch('changePassword', this.form_password)
          .then(() => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert('Đã cập nhật thông tin thành công. Vui lòng đăng nhập lại', 'THÔNG BÁO', () => {
              this.$store.dispatch('logout');
              this.$f7.views.main.router.navigate('/dang-nhap');
            });
          })
          .catch((err) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(err, 'LỖI!');
          });
    },
  },
  mounted(){
    this.form_password.old_password = this.old_password;
  }
};
</script>
